export default __webpack_public_path__ + "static/media/buildings.325983c0.svg";